import MaterialTable from "material-table";
import { useEffect } from "react";
import {
  Box,
  Button,
  Select,
  Typography,
  MenuItem,
  Grid,
  CircularProgress,
  IconButton,
  FormControl,
  TextField,
  FormLabel,
  InputLabel,
  Tooltip,
  Backdrop,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from "react";
import {
  ConvertDate,
  getDomain,
  getUserId,
} from "../../../Base/helper/baseFunctions";
import Popup from "../../../Base/views/Popup";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../../Constants/baseConstant";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import Papa from "papaparse";
import Warning from "../../images/report.png";
import { useDispatch, useSelector } from "react-redux";
import { GetAdjustmentComponentsAction } from "../../../../../store/Finance/PayRollTemplate/Action";
import { PayPeriodDateHelper } from "../../helper/Reports/GetWageReportHelper";
import { GetPayrollReportingEmployeeHelper } from "../../helper/PostAdjustment/EmployeePostAdjustmentHelper";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import {
  AddManualWageBulkStagetoMainHelper,
  DeleteManualWageBulkStageHelper,
  GetManualWageBulkStageHelper,
  UpdateManualWageBulkStageHelper,
} from "../../helper/BulkUpload/ManualWageBulkHelper";
import { GetPayrollUngriggeredMonthsHelper } from "../../helper/PayrollManagement/PayrollManagement";
const ManualWageBulkUpload = () => {
  const date = new Date();
  const currentMonth = date.getMonth() + 1;
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [Import, setImport] = useState(false);
  const [show, setShow] = useState(false);
  const [prefillOpen, setPrefillOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [editedRecord, setEditedRecord] = useState(null);
  const [id, setId] = useState();
  const [openPopup, setOpenPopup] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [empdata, setEmpData] = useState([]);
  const [stageData, setStageData] = useState([]);
  const [tab, setTab] = useState("")
  const [hoursdata, setHoursData] = useState([]);
  const [file, setFile] = useState(null);
  const [updating, setUpdating] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [dataLoading, setDataLoading] = useState(false);
  const convertDateToISO = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    const day = parts[0].padStart(2, "0");
    const month = parts[1].padStart(2, "0");
    const year = parts[2];
    return `${year}-${month}-${day}`;
  };
  const dispatch = useDispatch();
  const { adjustment_components_data } = useSelector(
    (state) => state.FinanceReducer?.PayrollTemplateReducer
  );
  const initialMonthYear = {
    month_year: `${date.getFullYear()}-${
      date.getMonth() + 1
    }-${date.getDate()}`,
  };
  const [filters, setFilters] = useState(initialMonthYear);
  const [selectedOption, setSelectedOption] = useState("Adjustments");
  const [selectedComponent, setSelectedComponent] = useState("");
  const [lastPayrollMonth, setLastPayrollMonth] = useState(currentMonth.toString());
  const [lastPayrollMonthWorkBased, setLastPayrollMonthWorkBased] = useState(currentMonth.toString());
  const disableMonths = selectedOption === "Adjustments" ? lastPayrollMonth : lastPayrollMonthWorkBased;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setDataLoading(true);
        const [manualWageRes] = await Promise.all([
          GetManualWageBulkStageHelper(),
        ]);
        setDataLoading(false);
        const manualWageData = manualWageRes?.data?.data?.[0];
        if (manualWageData?.adjustment_component_details) {
          setEmpData(manualWageData.adjustment_component_details);
          setStageData(manualWageRes?.data?.data);
          setId(manualWageData?.adjustment_component_detail_stage_pk);
          setTab(manualWageData?.tab)
        }
      } catch (error) {
        console.error("Failed to fetch payentry stage data", error);
      }
    };

    fetchData();
  }, []);
  const handleImport = (type) => {
    if (empdata?.length > 0) {
      setShowConfirmPopup(true);
    } else {
      if(stageData?.length > 0){
          handleCancel();
      }
      setImport(true);
    }
    setSelectedOption(type)
  };
  const fileSelected = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    if (!selectedFile.name.endsWith(".csv")) {
      setShow(true);
      return;
    }
    // processFile(selectedFile, e);
    processCSVFile(selectedFile, e);
  };

  const processCSVFile = (selectedFile, event) => {
    setFile(selectedFile);
    setUploadProgress(0);
    toast.info("Reading CSV File. Please wait...");
    Papa.parse(selectedFile, {
      header: true,
      skipEmptyLines: true,
      beforeFirstChunk: (chunk) => {
                const filteredChunk = chunk
                    ?.split("\n")
                    ?.filter(line => !line?.trim()?.startsWith("#"))
                    ?.join("\n");
                return filteredChunk;
            },
      complete: (result) => {
        const processedData = processDailyHoursCSV(result.data);
        setHoursData(processedData);
        toast.dismiss();
        toast.success("File imported successfully!");
      },
      error: (error) => {
        toast.error(`Error reading CSV file: ${error.message}`);
      },
    });

    if (event) event.target.value = "";
  };
  const checkComponentType = (data) => {
    if (data === "deduction") {
      return "Deduction";
    } else if (data === "earning") {
      return "Earning";
    } else {
      return "";
    }
  };
  const processDailyHoursCSV = (data) => {
    if (data.length === 0) return [];
    const headers = Object.keys(data[0]);
    const normalizedHeaders = headers.map((h) => h.trim().toLowerCase());
    const empIdKey = headers.find((key, idx) =>
      normalizedHeaders[idx].includes("emp id")
    );
    const dateHeaderRegex = /^\d{2}-\d{2}-\d{4}$/;
    const dateColumns = headers.filter((h) => dateHeaderRegex.test(h.trim()));

    const groupedRecords = {};

    data.forEach((row) => {
      const empId = row[empIdKey] || null;
      if (!empId) return;

      dateColumns.forEach((dateCol) => {
        const rawValue = row[dateCol];
        const amount =
          rawValue && rawValue.trim() !== "" ? rawValue.trim() : "0";
        if (Number(amount) < 0) return;

        const record_date = convertDateToISO(dateCol.trim());

        const record = {
          previous_employee_id: empId,
          component_json: JSON.stringify({
            post_adjustment_components_id:
              selectedComponent?.post_adjustment_components_id
                ?.post_adjustment_components_id,
            label: selectedComponent?.post_adjustment_components_id?.label,
            name: selectedComponent?.post_adjustment_components_id?.name,
            taxable_flag: Boolean(
              selectedComponent?.post_adjustment_components_id?.taxable_flag
            ),
            component_type:
              selectedComponent?.post_adjustment_components_id?.component_type,
            amount: amount,
          }),
          amount,
          flag: checkComponentType(
            selectedComponent?.post_adjustment_components_id?.component_type
          ),
          record_date,
        };

        if (!groupedRecords[empId]) {
          groupedRecords[empId] = [];
        }
        groupedRecords[empId].push(record);
      });
    });

    return Object.entries(groupedRecords).map(([empId, records]) => ({
      previous_employee_id: empId,
      records,
    }));
  };

  const [adjComponentData, setAdjComponentData] = useState({
    load: true,
    values: [],
  });

  const validate = () => {
    const temp = {};
    if (!file) temp.file = "File is required";

    if (!filters?.month_year) {
      toast.error("Please choose Year and Month.");
      return;
    }
    if (!selectedComponent?.post_adjustment_components_id) {
      toast.error("Please select wage component.");
      return;
    }
    return Object.keys(temp).length === 0; // Return true if no errors
  };

  async function addAdjustmentStage(e) {
    if (!validate()) return; // check validation only for fields in popup
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("user_id", getUserId());
      formData.append(
        "tab",
        selectedOption === "Adjustments" ? "adjustment" : "daily wages"
      ); // adjustment  "daily wages"
      formData.append("domain_name", getDomain());

      const [f_year, month] = filters.month_year.split("-");
      const f_month = parseInt(month, 10).toString();
      formData.append("month", f_month);
      formData.append("year", f_year);
      formData.append("adjustments_details_json", JSON.stringify(hoursdata));

      toast.info("Uploading file");
      try {
        setUploadProgress(0);
        await axiosInstance
          .post("/finance/uploadManualWageBulkFile", formData, {
            baseURL: HRMS_FINANCE_API_URL,
            headers: {
              Accept: "multipart/form-data",
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progress) => {
              const percentCompleted = Math.round(
                (progress.loaded * 90) / progress.total
              );
              setUploadProgress(percentCompleted);
              if (percentCompleted > 89) {
                toast.dismiss();
                toast.info("Processing...");
              }
            },
          })
          .then((response) => {
            const result = response?.data?.statuscode;
            setEmpData(response?.data?.data?.[0]?.adjustment_component_details);
            setId(
              response?.data?.data?.[0]?.adjustment_component_detail_stage_pk
            );
            setStageData(response?.data?.data);
            setTab(response?.data?.data?.[0]?.tab)
            if (result) {
              toast.dismiss();
              setSelectedComponent("");
              toast.success("File processed successfully!");
              setFilters(initialMonthYear);
            }
          });

        setUploadProgress(100);
        setFile(null);
        setImport(false);
      } catch (error) {
        setUploadProgress(0);
        toast.warning(error.response?.data?.message || error.message);
      }
    } catch (error) {
      console.error("Unexpected error", error);
    }
  }
  async function handleSubmit(e) {
    setIsLoading(true);
    AddManualWageBulkStagetoMainHelper().then((res) => {
      if (res.data.statuscode === 200) {
        toast.dismiss();
        toast.success("PayEntry bulk upload completed successfully.");
        setEmpData([]);
        setIsLoading(false);
      } else {
        toast.dismiss();
        setIsLoading(false);
        toast.error("The bulk upload failed. Please try again");
      }
    });
  }

  const handleCancel = () => {
    setShowConfirmPopup(false);
    setIsLoading(true);
    DeleteManualWageBulkStageHelper({
      adjustment_component_detail_stage_pk: null,
    }).then((res) => {
      setIsLoading(false);
      setEmpData([]); // Clear table data
      setFile(null); // Allow new file selection
      setImport(true);
    });
  };
  const handleEdit = (rowData) => {
    setEditedRecord(rowData);
    setOpenPopup(true);
  };
  const handleConfirmDelete = (rowData) => {
    setOpenDialog(true);
    setCurrentData(rowData);
  };
  const handleDelete = () => {
    const updatedData = empdata?.filter(
      (emp) => emp?.previous_employee_id !== currentData?.previous_employee_id
    );
    const cleanedUpdatedData = updatedData?.map(
      ({ tableData, ...rest }) => rest
    );
    setOpenDialog(false);
    UpdateManualWageBulkStageHelper({
      adjustment_component_detail_stage_pk: id,
      adjustments_details_json: JSON.stringify(cleanedUpdatedData),
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        const manualWageData = res?.data?.data?.[0];
        if (manualWageData?.adjustment_component_details) {
          setEmpData(manualWageData.adjustment_component_details);
          setId(manualWageData.adjustment_component_detail_stage_pk);
          setTab(manualWageData.tab);
          setStageData(res?.data?.data);
        }
        toast.success("Record deleted successfully!");
      } else {
        toast.error("Something went wrong");
      }
    });
  };
  const validateFields = () => {
    const tempErrors = {};
    if (!editedRecord?.previous_employee_id) {
      tempErrors.previous_employee_id = "Prev.Emp ID is required.";
      toast.error("Prev.Emp ID is required.");
      return;
    }
    return Object.keys(tempErrors).length === 0; // Return true if no errors
  };
  const handleEditSubmit = (updatedRecord) => {
    if (!validateFields()) return;
    const updatedData = empdata?.map((emp) =>
      emp?.tableData?.id === updatedRecord?.tableData?.id ? updatedRecord : emp
    );
    const cleanedUpdatedData = updatedData?.map(
      ({ tableData, ...rest }) => rest
    );
    setUpdating(true);
    UpdateManualWageBulkStageHelper({
      adjustment_component_detail_stage_pk: id,
      adjustments_details_json: JSON.stringify(cleanedUpdatedData),
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        const manualWageData = res?.data?.data?.[0];
        if (manualWageData?.adjustment_component_details) {
          setEmpData(manualWageData.adjustment_component_details);
          setId(manualWageData?.adjustment_component_detail_stage_pk);
          setTab(manualWageData?.tab);
        }
        setOpenPopup(false); // Close popup
        setUpdating(false);
        toast.success("Record updated successfully!");
      } else {
        setUpdating(false);
        setOpenPopup(false); // Close popup
        toast.error("Something went wrong");
      }
    });
  };


  const getDateRangeHeaders = (startDate, endDate) => {
    const headers = [];
    const start = new Date(startDate);
    const end = new Date(endDate);

    while (start <= end) {
      const dd = String(start.getDate()).padStart(2, "0");
      const mm = String(start.getMonth() + 1).padStart(2, "0");
      const yyyy = start.getFullYear();
      headers.push(`${dd}-${mm}-${yyyy}`);
      start.setDate(start.getDate() + 1);
    }

    return headers;
  };

  const handleClose = () => {
    setSelectedOption("Adjustments");
    setPrefillOpen(false);
    setImport(false);
    setFilters(initialMonthYear);
    setFile(null);
  };

  useEffect(() => {
    if (adjustment_components_data) {
      const mappedData = (adjustment_components_data || [])?.map((item) => ({
        label: item?.post_adjustment_components?.label,
        name: item?.post_adjustment_components?.name,
        taxable_flag: item?.taxable_flag || false,
        labelShow:
          `${item?.post_adjustment_components?.label} - ${
            item?.post_adjustment_components?.component_type === "earning"
              ? "Earning"
              : "Deduction"
          }` || "",
        component_type: item?.post_adjustment_components?.component_type || "",
        post_adjustment_components_id: item?.post_adjustment_components_id,
      }));
      setAdjComponentData({ load: false, values: mappedData });
    }
  }, [adjustment_components_data]);
  useEffect(() => {
    dispatch(GetAdjustmentComponentsAction());
  }, [dispatch]);

  const handleAdjComponents = (data) => {
    if (adjustment_components_data) {
      const mappedData = (adjustment_components_data || [])?.map((item) => ({
        label: item?.post_adjustment_components?.label,
        name: item?.post_adjustment_components?.name,
        taxable_flag: item?.taxable_flag || false,
        labelShow:
          `${item?.post_adjustment_components?.label} - ${
            item?.post_adjustment_components?.component_type === "earning"
              ? "Earning"
              : "Deduction"
          }` || "",
        component_type: item?.post_adjustment_components?.component_type || "",
        post_adjustment_components_id: item?.post_adjustment_components_id,
      }));
      setAdjComponentData({ load: false, values: mappedData });
    }
  };

  const handleMenuItemClick = (selected) => {
    setPrefillOpen(true);
  };
  const Guides = [
        "PayEntry Guide (Input Format)",
        "Prev.Emp ID: Reference ID / Employee ID from the legacy system / Org ID / Biometric ID as applicable.",
        "Dates : dd-mm-yyyy format (e.g. 01-01-2025)",
        "Do Not remove these lines starting with '#' (they are for guidance only)"
    ];
 
  const handleExportCSV = async () => {
    const [f_year, month_value] = filters?.month_year.split("-");
    let headers = [];
    setLoader(true);
    let fileName = `PayEntry_${selectedOption}_Template_${month_value}_${f_year}.csv`;
    headers = ["Prev.Emp ID", "Employee Name"];

    try {
      let csvData = [];
      const res = await PayPeriodDateHelper({
        month: month_value,
        year: f_year,
      });
      const resEmp = await GetPayrollReportingEmployeeHelper({
        daily_wage: !(selectedOption === "Adjustments"),
      });
      const resEmpData =
        resEmp?.data?.statuscode === 200 ? resEmp?.data?.data : [];

      const responseData = res?.data?.statuscode === 200 ? res?.data?.data : [];
      const startDate = responseData[0]?.start_date;
      const endDate = responseData[0]?.end_date;
      const totalDays =
        startDate && endDate
          ? Math.ceil(
              (new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24)
            ) + 1
          : 31;
      if (startDate && endDate) {
        const dateHeaders = getDateRangeHeaders(startDate, endDate);
        headers.push(...dateHeaders);
      }
      const formattedData = [headers];
      resEmpData?.forEach((emp) => {
        const row = [
          emp.previous_employee_id,
          emp.employee_name,
          ...Array(totalDays).fill("0"),
        ];
        formattedData.push(row);
      });

      csvData = formattedData;

      const ws = XLSX.utils.aoa_to_sheet(csvData);
      let csv = XLSX.utils.sheet_to_csv(ws);
      
      if (Guides?.length > 0) {
          const guideText = Guides?.map(line => `########## ${line} ##########`)?.join("\n") + "\n####\n####\n";
          csv = guideText + csv;
      }

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("CSV Export Failed:", error);
    } finally {
      setLoader(false);
      setSelectedOption("Adjustments");
      setSelectedComponent("");
      setPrefillOpen(false);
      setFilters(initialMonthYear);
    }
  };
 useEffect(() => {
  const [f_year] = filters.month_year.split("-");
  GetPayrollUngriggeredMonthsHelper({current_year: f_year}).then((res) => {
    if(res?.data?.statuscode === 200) {
      setLastPayrollMonth(res?.data?.data?.[0]?.regular_latest_month)
      setLastPayrollMonthWorkBased(res?.data?.data?.[0]?.workbased_latest_month)
    }
  })
 }, [filters?.month_year])
  return (
    <>
      <>
        <Popup
          maxWidth="xs"
          openPopup={show}
          setOpenPopup={setShow}
          close={false}
          hideDividers={true}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <Box sx={{ mt: 1, mb: 1, textAlign: "center !important" }}>
              <img src={Warning} alt="UnSupport File" width={"25%"} />
            </Box>
            <FormControl>
              <FormLabel id="gender-label">
                <Typography variant="h5" className="blink">
                  Invalid File Type, Accepted file type is .csv
                </Typography>
              </FormLabel>
            </FormControl>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "10px",
              }}
            >
              <Button
                onClick={() => {
                  setShow(false);
                }}
                variant="contained"
                type="submit"
                className="mpl-primary-btn profile-btn"
                size="small"
                sx={{
                  margin: "10px",
                }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Popup>
        <Box sx={{ minHeight: "calc(100vh - 115px)", maxHeight: "87vh", overflowY: "auto", position: "relative" }}>
          <Backdrop
              open={dataLoading}
              sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                position: "absolute",
                borderRadius: "inherit",
              }}
            >
              <CircularProgress />
          </Backdrop>

          <Grid
            container
            spacing={1}
            sx={{
              padding: "5px 14px 10px 14px",
              borderRadius: "12px",
              boxShadow: 2,
              width: "100%",
              maxWidth: "800px",
              margin: "2px auto",
              mb: 1,
              minHeight: "100px"
            }}
          >
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                  color: "inherit",
                  height: "32px",
                }}
              >
                Import CSV
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item>
                  <Button
                    variant="contained"
                    className="mpl-primary-btn"
                    component="span"
                    startIcon={<UploadFileIcon />}
                    sx={{
                      textTransform: "none",
                      fontSize: "14px",
                      padding: "8px 20px",
                      height: "41px",
                    }}
                    onClick={() => handleImport("Adjustments")}
                  >
                    Adjustments
                  </Button>
                </Grid>

                <Grid item>
                  <Button
                    variant="contained"
                    className="mpl-primary-btn"
                    component="span"
                    startIcon={<UploadFileIcon />}
                    sx={{
                      textTransform: "none",
                      fontSize: "14px",
                      padding: "8px 20px",
                      height: "41px",
                    }}
                    onClick={() => handleImport("Work-Based Pay")}
                  >
                    Work-Based Pay
                  </Button>
                </Grid>

                <Grid item>
                  <Button
                    variant="contained"
                    className="mpl-primary-btn"
                    disabled={empdata?.length === 0 || empdata === undefined}
                    onClick={handleSubmit}
                    sx={{
                      textTransform: "none",
                      fontSize: "14px",
                      padding: "8px 20px",
                      height: "41px",
                      minWidth: "75px",
                      boxShadow: empdata?.length > 0 ? 3 : 0,
                    }}
                  >
                    Submit
                  </Button>
                </Grid>
                <Grid item xs={5} sx={{display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "end",}}>
                  <Box
                    sx={{
                      padding: "5px",
                      borderRadius: "8px",
                      backgroundColor: "#ffffff",
                      border: "1px solid #dce3ea",
                      cursor: "pointer",
                      width: "250px",
                      transition: "all 0.2s ease-in-out",
                      "&:hover": {
                        backgroundColor: "#e8f5e9",
                      },
                    }}
                    onClick={(e) => handleMenuItemClick(e)}
                  >
                    <Typography variant="body1" sx={{ fontWeight: 500, color: "#1976d2" }}>
                      {loader ? (
                        <span
                          role="img"
                          aria-label="refresh"
                          style={{
                            display: "inline-block",
                            animation: "spin 1s linear infinite",
                          }}
                        >
                          🔄
                        </span>
                      ) : (
                        <span role="img" aria-label="refresh">
                          🔄
                        </span>
                      )}{" "}
                      Download Prefill CSV Template
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid>

          </Grid>

          {empdata?.length > 0 && (
            <MaterialTable
              isLoading={isLoading}
              columns={[
                {
                  title: "Prev.Emp ID",
                  field: "previous_employee_id",
                  cellStyle: { padding: "10px 10px 10px 13px" },
                  grouping: false,
                },
                {
                  title: "Wage Component",
                  field: "",
                  cellStyle: { padding: "10px 10px 10px 13px" },
                  grouping: false,
                   render: (rowData) => {
                        try {
                        const component = JSON.parse(rowData?.records?.[0]?.component_json || "{}");
                        return `${component?.label || "-"} - ${component?.component_type === "earning" ? "Earning" : "Deduction" || "-"}`;
                        } catch (error) {
                        return "-";
                        }
                    }
                },

              ]}
              data={empdata}
              options={{
                maxBodyHeight: "65vh",
                minBodyHeight: "65vh",
                rowStyle: { fontSize: "13px" },
                headerStyle: {
                  padding: "10px 10px 10px 13px",
                  fontWeight: "bold",
                },
                sorting: true,
                search: true,
                searchText: "",
                searchFieldAlignment: "right",
                searchAutoFocus: true,
                searchFieldVariant: "standard",
                filtering: false,
                paging: true,
                pageSizeOptions: [25, 50],
                pageSize: 25,
                paginationType: "stepped",
                showFirstLastPageButtons: false,
                paginationPosition: "bottom",
                exportButton: false,
                exportAllData: false,
                exportFileName: "Bio Metric",
                addRowPosition: "first",
                selection: false,
                actionsColumnIndex: -1,
                showSelectAllCheckbox: true,
                showTextRowsSelected: true,
                grouping: false,
                columnsButton: false,
              }}
              actions={[
                {
                  icon: () => (
                    <IconButton sx={{ padding: "0px" }}>
                      <EditIcon />
                    </IconButton>
                  ),
                  tooltip: "Edit",
                  onClick: (_event, rowData) => {
                    handleEdit(rowData);
                  },
                },
                {
                  icon: () => (
                    <IconButton sx={{ padding: "0px" }}>
                      <DeleteIcon />
                    </IconButton>
                  ),
                  tooltip: "Delete",
                  onClick: (_event, rowData) => {
                    handleConfirmDelete(rowData);
                  },
                },
              ]}
              title={`PayEntry Bulk Upload: ${tab === "adjustment" ? "Adjustments" : "Work-Based Pay"}`}
            />
          )}

          {/* edit stage data popup */}
          <Popup
            fullWidth
            title={`Edit PayEntry: ${tab === "adjustment" ? "Adjustments" : "Work-Based Pay"}`}
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
          >
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleEditSubmit(editedRecord);
              }}
            >
              <TextField
                variant="standard"
                size="small"
                label="Previous Employee ID"
                value={editedRecord?.previous_employee_id || ""}
                onChange={(e) =>
                  setEditedRecord({
                    ...editedRecord,
                    previous_employee_id: e.target.value,
                  })
                }
                fullWidth
                sx={{ mb: 3 }}
                required
              />
              <Grid container spacing={1.5}>
                {editedRecord?.records &&
                  editedRecord?.records?.map((day, index) => (
                    <Grid item xs={4} key={`record_${index}`}>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item xs={6} sx={{ textAlign: "left" }}>
                          <Typography variant="body2" fontWeight="bold">
                            {/^(\d{4})-(\d{2})-(\d{2})$/.test(day?.record_date)
                              ? `${ConvertDate(day?.record_date)}`
                              : `Date ${day?.record_date}`}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            variant="standard"
                            size="small"
                            value={day?.amount || ""}
                            type="number"
                            onChange={(e) => {
                              const newAmount = e.target.value;
                              if(newAmount < 0 ) return;
                              const updatedRecords = [...editedRecord.records];
                              const targetRecord = updatedRecords[index];
                              targetRecord.amount = newAmount;

                              const parsedComponent = JSON.parse(
                                targetRecord.component_json
                              );
                              parsedComponent.amount = newAmount;
                              targetRecord.component_json =
                                JSON.stringify(parsedComponent);

                              setEditedRecord({
                                ...editedRecord,
                                records: updatedRecords,
                              });
                            }}
                            sx={{
                              width: "60px",
                              "& .MuiInputBase-root": {
                                height: 30,
                                textAlign: "center",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                              "& .MuiOutlinedInput-input": {
                                padding: "5px",
                                textAlign: "center",
                              },
                            }}
                            inputProps={{ style: { textAlign: "center" },  min: 0 }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
              </Grid>
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
              >
                <Button
                  onClick={() => setOpenPopup(false)}
                  className="mpl-primary-btn"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  className="mpl-primary-btn"
                >
                  {updating ? <CircularProgress size={"20px"} /> : "Save"}
                </Button>
              </Box>
            </form>
          </Popup>
          <Popup
            maxWidth="sm"
            fullWidth={true}
            title={`PayEntry Bulk Import: ${selectedOption}`}
            openPopup={Import}
            close={false}
            setOpenPopup={setImport}
          >
            <Box sx={{ m: 1 }}>
              <Grid
                container
                alignItems="center"
                rowSpacing={2}
                columnSpacing={4}
              >
                <Grid item xs={12} sm={6} pb={"2px"}>
                  <FormControl fullWidth size="small">
                    <CommonDatePicker
                      name="month_year"
                      openTo="month"
                      required
                      views={["year", "month"]}
                      label="Month and Year"
                      pickerType="date"
                      variant="standard"
                      onKeyDown={(e) => e.preventDefault()}
                      onKeyPress={(e) => e.preventDefault()}
                      pickerFormat="MM/yyyy"
                      DefaultDTvalue={filters.month_year}
                      minDate={new Date(new Date().getFullYear(), parseInt(disableMonths, 10), 1)}
                      maxDate={new Date(new Date().getFullYear(),new Date().getMonth() + 6, 1)}
                      handleChange={(value) =>
                        setFilters({
                          month_year: value
                            ? `${value?.getFullYear()}-${(
                                "0" +
                                (value?.getMonth() + 1)
                              ).slice(-2)}-${("0" + value?.getDate()).slice(
                                -2
                              )}`
                            : "",
                        })
                      }
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <SelectableSearch
                      isOptionEqualToValue={(option, value) =>
                        +option.post_adjustment_components_id ===
                        +value.post_adjustment_components_id
                      }
                      label="Select Wage Component"
                      fullWidth
                      value={
                        selectedComponent?.post_adjustment_components_id || ""
                      }
                      loading={() => handleAdjComponents()}
                      fieldLabel="label"
                      name="post_adjustment_components_id"
                      required={true}
                      variantType={"standard"}
                      size="small"
                      onChangeEvent={(e, value) => {
                        setSelectedComponent({
                          post_adjustment_components_id: {
                            ...value,
                          },
                        });
                        setFile(null);
                      }}
                      data={adjComponentData}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    justifyContent: "center",
                    margin: "20px 0px 20px 0px",
                  }}
                >
                  <label
                    htmlFor="contained-button-file"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "2px dashed #883bd5",
                      padding: "50px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      backgroundColor: "#fff",
                      width: "300px",
                      textAlign: "center",
                      fontSize: "14px",
                      color: "#883bd5",
                    }}
                  >
                    {file
                      ? file?.name?.substring(0, 20) + "..."
                      : "Select File"}
                    <input
                      accept=".csv"
                      id="contained-button-file"
                      type="file"
                      style={{ display: "none" }}
                      multiple={false}
                      onChange={fileSelected}
                    />
                  </label>
                </div>
              </>

              <Box
                sx={{ display: "flex", justifyContent: "space-between", m: 2 }}
              >
                <Button
                  onClick={() => handleClose()}
                  className="mpl-primary-btn"
                  disabled={uploadProgress > 0 && uploadProgress < 100}
                >
                  Close
                </Button>

                <div>
                    <Tooltip title={file ? "" : "Please select a file"}>
                      <span>
                        <Button
                          disabled={!file || (uploadProgress > 0 && uploadProgress < 100)}
                          variant="contained"
                          type="submit"
                          className="mpl-primary-btn"
                          onClick={addAdjustmentStage}
                          startIcon={(uploadProgress > 0 && uploadProgress < 100) ? <CircularProgress size={18} color="inherit" /> : null}
                        >
                          Upload
                        </Button>
                      </span>
                    </Tooltip>
                </div>
              </Box>
            </Box>
          </Popup>

          {/* // prefill download popup */}
          <Popup
            maxWidth="sm"
            fullWidth={true}
            title="Prefill Template"
            openPopup={prefillOpen}
            close={false}
            setOpenPopup={setPrefillOpen}
          >
            <Box sx={{ m: 1 }}>
              <Grid container spacing={3} alignItems="center" mb={4} rowSpacing={2}
                columnSpacing={4}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel
                      id="adjustment-label"
                      sx={{ marginLeft: "-15px", paddingTop: "5px" }}
                    >
                      PayEntry Type
                    </InputLabel>
                    <Select
                      labelId="adjustment-label"
                      id="adjustment-select"
                      value={selectedOption}
                      label="Manual Wage Entry Type"
                      variant="standard"
                      onChange={(e) => setSelectedOption(e.target.value)}
                    >
                      <MenuItem value="Adjustments">Adjustments</MenuItem>
                      <MenuItem value="Work-Based Pay">Work-Based Pay</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6} pb={"2px"}>
                  <FormControl fullWidth size="small">
                    <CommonDatePicker
                      name="month_year"
                      openTo="month"
                      required
                      views={["year", "month"]}
                      label="Month and Year"
                      pickerType="date"
                      variant="standard"
                      onKeyDown={(e) => e.preventDefault()}
                      onKeyPress={(e) => e.preventDefault()}
                      pickerFormat="MM/yyyy"
                      DefaultDTvalue={filters.month_year}
                      minDate={new Date(new Date().getFullYear(), parseInt(disableMonths, 10), 1)}
                      maxDate={new Date(new Date().getFullYear(),new Date().getMonth() + 2, 1)}
                      handleChange={(value) =>
                        setFilters({
                          month_year: value
                            ? `${value?.getFullYear()}-${(
                                "0" +
                                (value?.getMonth() + 1)
                              ).slice(-2)}-${("0" + value?.getDate()).slice(
                                -2
                              )}`
                            : "",
                        })
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Box
                sx={{ display: "flex", justifyContent: "space-between", m: 2 }}
              >
                <Button
                  onClick={() => handleClose()}
                  className="mpl-primary-btn"
                >
                  Close
                </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    className="mpl-primary-btn"
                    onClick={handleExportCSV}
                    disabled={loader}
                    startIcon={loader ? <CircularProgress size={18} color="inherit" /> : null}
                  >
                    Download
                  </Button>
              </Box>
            </Box>
          </Popup>

          {/* confirmation message if stage data is there to delete */}
          <Popup
            maxWidth="xs"
            fullWidth={true}
            title="Attention Needed!"
            openPopup={showConfirmPopup}
            close={false}
            setOpenPopup={setShowConfirmPopup}
          >
            <Typography variant="h5">
              {" "}
              You will lose the imported data. Do you want to submit it before
              proceeding?{" "}
            </Typography>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
            >
              <Button onClick={handleCancel} className="mpl-primary-btn">
                No
              </Button>

              <Button
                onClick={() => {
                  setShowConfirmPopup(false);
                }}
                className="mpl-primary-btn"
              >
                Yes
              </Button>
            </Box>
          </Popup>
          <ConfirmationDialog
            title="Do you wish to proceed?"
            openDialog={openDialog}
            closeDialog={setOpenDialog}
            OkButtonText="Delete"
            onSubmit={handleDelete}
          />
        </Box>
      </>
    </>
  );
};

export default ManualWageBulkUpload;
